import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { App } from './App';

// Set up MSW on development (local) builds.
// https://mswjs.io/docs/getting-started/integrate/browser
// https://github.com/mswjs/msw/discussions/712#discussioncomment-1080752
async function prepare(): Promise<void> {
  if (import.meta.env.DEV) {
    const { default: worker } = await import('./testing/mocks/browser');
    worker.start({
      onUnhandledRequest: 'bypass', // Use 'warn' here if you're debugging MSW
    });
  }
}

const router = createBrowserRouter([
  // match everything with "*"
  { path: '*', element: <App /> },
]);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);

prepare().then(() => {
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
});
